import store  from '@/utils/store'
export const columns = (vm) =>{
    return [
        {
            type: 'index',
            width: 50,
            label: '序号',
            align:'center',
            headerAlign:'center',
        },
       
        {
            label:'标题名称',
            prop:'problem',
            align:'left',
            headerAlign:'left',
            width:300,
            tooltip:true
        },
		{
		    label:'平台 ',
		    prop:'publishPlatform',
		    align:'center',
		    headerAlign:'center',
			render: (h, params) => {
			    let text = ""
			    let color = ""
			    let list = store.state.conText.accountTypeLists
			    for(var i in list){
			       if(params.row.publishPlatform*1 == list[i].val*1){
			          text = list[i].title
			        
			       }
			    }
			    return h('span',{style:{color:""}},text)
			}
		},
        {
            label:'操作时间',
            prop:'createTime',
            align:'center',
            headerAlign:'center',
            width:300,
        },
        {
            label:'操作人员',
            prop:'operator',
            align:'center',
            headerAlign:'center',
            tooltip:true,
        },
        {
            label:'操作',
            width:120,
            align:"center",
            headerAlign:"center",
            render: (h, params) => {
                let lookBtn = (h)=>{
                    return h('el-link',{
                        props:{
                            type:'primary',
                            underline:false
                        },
                        style:{
                            
                        },
                        on:{
                            click:()=>{vm.lookBtn(params.row)}
                        }
                    },'查看')
                }

                let eidtBtn = (h)=>{
                    return h('el-link',{
                        props:{
                            type:'primary',
                            underline:false
                        },
                        style:{
                            color:"#3AE2CE"
                        },
                        on:{
                            click:()=>{vm.eidtBtn(params.row)}
                        }
                    },'编辑')
                }

                let deleteBtn = (h)=>{
                    return h('el-link',{
                        props:{
                            type:'primary',
                            underline:false
                        },
                        style:{
                            color:"red"
                        },
                        on:{
                            click:()=>{vm.deleteBtn(params.row)}
                        }
                    },'删除')
                }

                let btnArr = [];
                btnArr.push(lookBtn(h));
                btnArr.push(eidtBtn(h));
                btnArr.push(deleteBtn(h));
                return h('div',{
                    style:{
                        display:"flex",
                        justifyContent:"space-between",
                        alignItems: "center"
                    }
                },btnArr)
            }
        }
    ]
}